// Kõik MM 2026 mängud — kuupäev, EET kellaaeg, meeskonnad, grupp/voor
// Ajad pärinevad worldcup26.ir API-st, teisendatud stadium_id ajavööndi järgi Eesti ajaks
export const GROUP_MATCHES = [
  // GRUPP A
{ id: 1, date: "11.06", time: "22:00", home: "Mehhiko", away: "Lõuna-Aafrika", group: "A" },
  { id: 2, date: "12.06", time: "05:00", home: "Lõuna-Korea", away: "Tšehhi", group: "A" },
  { id: 3, date: "18.06", time: "19:00", home: "Tšehhi", away: "Lõuna-Aafrika", group: "A" },
  { id: 4, date: "19.06", time: "04:00", home: "Mehhiko", away: "Lõuna-Korea", group: "A" },
  { id: 5, date: "25.06", time: "04:00", home: "Tšehhi", away: "Mehhiko", group: "A" },
  { id: 6, date: "25.06", time: "04:00", home: "Lõuna-Aafrika", away: "Lõuna-Korea", group: "A" },
  // GRUPP B
  { id: 7, date: "12.06", time: "22:00", home: "Kanada", away: "Bosnia", group: "B" },
  { id: 8, date: "13.06", time: "22:00", home: "Katar", away: "Šveits", group: "B" },
  { id: 9, date: "18.06", time: "22:00", home: "Šveits", away: "Bosnia", group: "B" },
  { id: 10, date: "19.06", time: "01:00", home: "Kanada", away: "Katar", group: "B" },
  { id: 11, date: "24.06", time: "22:00", home: "Šveits", away: "Kanada", group: "B" },
  { id: 12, date: "24.06", time: "22:00", home: "Bosnia", away: "Katar", group: "B" },
  // GRUPP C
  { id: 13, date: "14.06", time: "01:00", home: "Brasiilia", away: "Maroko", group: "C" },
  { id: 14, date: "14.06", time: "04:00", home: "Haiti", away: "Šotimaa", group: "C" },
  { id: 15, date: "20.06", time: "01:00", home: "Šotimaa", away: "Maroko", group: "C" },
  { id: 16, date: "20.06", time: "04:00", home: "Brasiilia", away: "Haiti", group: "C" },
  { id: 17, date: "25.06", time: "01:00", home: "Šotimaa", away: "Brasiilia", group: "C" },
  { id: 18, date: "25.06", time: "01:00", home: "Maroko", away: "Haiti", group: "C" },
  // GRUPP D
  { id: 19, date: "13.06", time: "04:00", home: "USA", away: "Paraguay", group: "D" },
  { id: 20, date: "14.06", time: "07:00", home: "Austraalia", away: "Türgi", group: "D" },
  { id: 21, date: "19.06", time: "22:00", home: "USA", away: "Austraalia", group: "D" },
  { id: 22, date: "20.06", time: "06:00", home: "Türgi", away: "Paraguay", group: "D" },
  { id: 23, date: "26.06", time: "05:00", home: "Türgi", away: "USA", group: "D" },
  { id: 24, date: "26.06", time: "05:00", home: "Paraguay", away: "Austraalia", group: "D" },
  // GRUPP E
  { id: 25, date: "14.06", time: "20:00", home: "Saksamaa", away: "Curaçao", group: "E" },
  { id: 26, date: "15.06", time: "02:00", home: "Elevandiluurannik", away: "Ecuador", group: "E" },
  { id: 27, date: "20.06", time: "23:00", home: "Saksamaa", away: "Elevandiluurannik", group: "E" },
  { id: 28, date: "21.06", time: "03:00", home: "Ecuador", away: "Curaçao", group: "E" },
  { id: 29, date: "25.06", time: "23:00", home: "Ecuador", away: "Saksamaa", group: "E" },
  { id: 30, date: "25.06", time: "23:00", home: "Curaçao", away: "Elevandiluurannik", group: "E" },
  // GRUPP F
  { id: 31, date: "14.06", time: "23:00", home: "Holland", away: "Jaapan", group: "F" },
  { id: 32, date: "15.06", time: "05:00", home: "Rootsi", away: "Tuneesia", group: "F" },
  { id: 33, date: "20.06", time: "20:00", home: "Holland", away: "Rootsi", group: "F" },
  { id: 34, date: "21.06", time: "07:00", home: "Tuneesia", away: "Jaapan", group: "F" },
  { id: 35, date: "26.06", time: "02:00", home: "Jaapan", away: "Rootsi", group: "F" },
  { id: 36, date: "26.06", time: "02:00", home: "Tuneesia", away: "Holland", group: "F" },
  // GRUPP G
  { id: 37, date: "15.06", time: "22:00", home: "Belgia", away: "Egiptus", group: "G" },
  { id: 38, date: "16.06", time: "04:00", home: "Iraan", away: "Uus-Meremaa", group: "G" },
  { id: 39, date: "21.06", time: "22:00", home: "Belgia", away: "Iraan", group: "G" },
  { id: 40, date: "22.06", time: "04:00", home: "Uus-Meremaa", away: "Egiptus", group: "G" },
  { id: 41, date: "27.06", time: "06:00", home: "Egiptus", away: "Iraan", group: "G" },
  { id: 42, date: "27.06", time: "06:00", home: "Uus-Meremaa", away: "Belgia", group: "G" },
  // GRUPP H
  { id: 43, date: "15.06", time: "19:00", home: "Hispaania", away: "Roheneemesaared", group: "H" },
  { id: 44, date: "16.06", time: "01:00", home: "Saudi Araabia", away: "Uruguay", group: "H" },
  { id: 45, date: "21.06", time: "19:00", home: "Hispaania", away: "Saudi Araabia", group: "H" },
  { id: 46, date: "22.06", time: "01:00", home: "Uruguay", away: "Roheneemesaared", group: "H" },
  { id: 47, date: "27.06", time: "03:00", home: "Roheneemesaared", away: "Saudi Araabia", group: "H" },
  { id: 48, date: "27.06", time: "03:00", home: "Uruguay", away: "Hispaania", group: "H" },
  // GRUPP I
  { id: 49, date: "16.06", time: "22:00", home: "Prantsusmaa", away: "Senegal", group: "I" },
  { id: 50, date: "17.06", time: "01:00", home: "Iraak", away: "Norra", group: "I" },
  { id: 51, date: "23.06", time: "03:00", home: "Norra", away: "Senegal", group: "I" },
  { id: 52, date: "23.06", time: "00:00", home: "Prantsusmaa", away: "Iraak", group: "I" },
  { id: 53, date: "26.06", time: "22:00", home: "Norra", away: "Prantsusmaa", group: "I" },
  { id: 54, date: "26.06", time: "22:00", home: "Senegal", away: "Iraak", group: "I" },
  // GRUPP J
  { id: 55, date: "17.06", time: "04:00", home: "Argentina", away: "Alžeeria", group: "J" },
  { id: 56, date: "17.06", time: "07:00", home: "Austria", away: "Jordaania", group: "J" },
  { id: 57, date: "22.06", time: "20:00", home: "Argentina", away: "Austria", group: "J" },
  { id: 58, date: "23.06", time: "06:00", home: "Jordaania", away: "Alžeeria", group: "J" },
  { id: 59, date: "28.06", time: "05:00", home: "Alžeeria", away: "Austria", group: "J" },
  { id: 60, date: "28.06", time: "05:00", home: "Jordaania", away: "Argentina", group: "J" },
  // GRUPP K
  { id: 61, date: "17.06", time: "20:00", home: "Portugal", away: "KD Kongo", group: "K" },
  { id: 62, date: "18.06", time: "05:00", home: "Usbekistan", away: "Kolumbia", group: "K" },
  { id: 63, date: "23.06", time: "20:00", home: "Portugal", away: "Usbekistan", group: "K" },
  { id: 64, date: "24.06", time: "05:00", home: "Kolumbia", away: "KD Kongo", group: "K" },
  { id: 65, date: "28.06", time: "02:30", home: "Kolumbia", away: "Portugal", group: "K" },
  { id: 66, date: "28.06", time: "02:30", home: "KD Kongo", away: "Usbekistan", group: "K" },
  // GRUPP L
  { id: 67, date: "17.06", time: "23:00", home: "Inglismaa", away: "Horvaatia", group: "L" },
  { id: 68, date: "18.06", time: "02:00", home: "Ghana", away: "Panama", group: "L" },
  { id: 69, date: "23.06", time: "23:00", home: "Inglismaa", away: "Ghana", group: "L" },
  { id: 70, date: "24.06", time: "02:00", home: "Panama", away: "Horvaatia", group: "L" },
  { id: 71, date: "28.06", time: "00:00", home: "Panama", away: "Inglismaa", group: "L" },
  { id: 72, date: "28.06", time: "00:00", home: "Horvaatia", away: "Ghana", group: "L" },
];


export const PLAYOFF_MATCHES = [
  // 1/32-finaalid — kinnitatud meeskonnad ja ajad (Eesti aeg)
  { id: 101, date: "28.06", time: "22:00", home: "Lõuna-Aafrika",     away: "Kanada",            label: "1/32-finaal 1",  round: "r32" },
  { id: 102, date: "29.06", time: "20:00", home: "Brasiilia",         away: "Jaapan",            label: "1/32-finaal 2",  round: "r32" },
  { id: 103, date: "29.06", time: "23:30", home: "Saksamaa",          away: "Paraguay",          label: "1/32-finaal 3",  round: "r32" },
  { id: 104, date: "30.06", time: "04:00", home: "Holland",           away: "Maroko",            label: "1/32-finaal 4",  round: "r32" },
  { id: 105, date: "30.06", time: "20:00", home: "Elevandiluurannik", away: "Norra",             label: "1/32-finaal 5",  round: "r32" },
  { id: 106, date: "01.07", time: "00:00", home: "Prantsusmaa",       away: "Rootsi",            label: "1/32-finaal 6",  round: "r32" },
  { id: 107, date: "01.07", time: "04:00", home: "Mehhiko",           away: "Ecuador",           label: "1/32-finaal 7",  round: "r32" },
  { id: 108, date: "01.07", time: "19:00", home: "Inglismaa",         away: "KD Kongo",          label: "1/32-finaal 8",  round: "r32" },
  { id: 109, date: "01.07", time: "23:00", home: "Belgia",            away: "Senegal",           label: "1/32-finaal 9",  round: "r32" },
  { id: 110, date: "02.07", time: "03:00", home: "USA",               away: "Bosnia",            label: "1/32-finaal 10", round: "r32" },
  { id: 111, date: "02.07", time: "22:00", home: "Hispaania",         away: "Austria",           label: "1/32-finaal 11", round: "r32" },
  { id: 112, date: "03.07", time: "02:00", home: "Portugal",          away: "Horvaatia",         label: "1/32-finaal 12", round: "r32" },
  { id: 113, date: "03.07", time: "06:00", home: "Šveits",            away: "Alžeeria",          label: "1/32-finaal 13", round: "r32" },
  { id: 114, date: "03.07", time: "21:00", home: "Austraalia",        away: "Egiptus",           label: "1/32-finaal 14", round: "r32" },
  { id: 115, date: "04.07", time: "01:00", home: "Argentina",         away: "Roheneemesaared",   label: "1/32-finaal 15", round: "r32" },
  { id: 116, date: "04.07", time: "04:30", home: "Kolumbia",          away: "Ghana",             label: "1/32-finaal 16", round: "r32" },
  // 1/16-finaalid
  { id: 117, date: "04.07", time: "21:00", home: "Kanada", away: "Maroko", label: "1/16-finaal 1", round: "r16" },
  { id: 118, date: "05.07", time: "00:00", home: "Paraguay", away: "Prantsusmaa", label: "1/16-finaal 2", round: "r16" },
  { id: 119, date: "05.07", time: "23:00", home: "Brasiilia", away: "Norra", label: "1/16-finaal 3", round: "r16" },
  { id: 120, date: "06.07", time: "05:00", home: "Mehhiko", away: "Inglismaa", label: "1/16-finaal 4", round: "r16" },
  { id: 121, date: "06.07", time: "23:00", home: "Portugal", away: "Hispaania", label: "1/16-finaal 5", round: "r16" },
  { id: 122, date: "07.07", time: "06:00", home: "USA", away: "Belgia", label: "1/16-finaal 6", round: "r16" },
  { id: 123, date: "07.07", time: "19:00", home: "Argentina", away: "Egiptus", label: "1/16-finaal 7", round: "r16" },
  { id: 124, date: "08.07", time: "02:00", home: "Šveits", away: "Kolumbia", label: "1/16-finaal 8", round: "r16" },
  // Veerandfinaalid
  { id: 125, date: "09.07", time: "23:00", home: "Prantsusmaa", away: "Maroko", label: "Veerandfinaal 1", round: "qf" },
  { id: 126, date: "10.07", time: "22:00", home: "Hispaania", away: "Belgia", label: "Veerandfinaal 2", round: "qf" },
  { id: 127, date: "12.07", time: "00:00", home: "Norra", away: "Inglismaa", label: "Veerandfinaal 3", round: "qf" },
  { id: 128, date: "12.07", time: "04:00", home: "Argentina", away: "Šveits", label: "Veerandfinaal 4", round: "qf" },
  // Poolfinaalid
  { id: 129, date: "14.07", time: "22:00", home: "Prantsusmaa", away: "Hispaania", label: "Poolfinaal 1", round: "sf" },
  { id: 130, date: "15.07", time: "22:00", home: "Inglismaa", away: "Argentina", label: "Poolfinaal 2", round: "sf" },
  // Pronksmäng + finaal
  { id: 131, date: "19.07", time: "00:00", home: "Prantsusmaa", away: "Inglismaa", label: "Pronksmäng", round: "3rd" },
  { id: 132, date: "19.07", time: "22:00", home: "Hispaania", away: "Argentina", label: "FINAAL", round: "final" },
];

export const ALL_MATCHES = [...GROUP_MATCHES, ...PLAYOFF_MATCHES];

export const GROUPS = ["A","B","C","D","E","F","G","H","I","J","K","L"];

export const ROUND_LABELS = {
  r32:   "1/32-finaalid",
  r16:   "1/16-finaalid",
  qf:    "Veerandfinaalid",
  sf:    "Poolfinaalid",
  "3rd": "Pronksmäng",
  final: "Finaal",
};

// MM 2026 võitja — kinnitatud pärast finaali. Kasutatakse +7p võitja-
// ennustuse boonuse arvutamiseks. Tühjaks jätta enne finaali lõppu.
export const TOURNAMENT_WINNER = "Hispaania";
